import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { BulkContentTagDocument } from './bulk.generated';

export const useBulkContentTag = (options: ApiOptions<typeof BulkContentTagDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(BulkContentTagDocument, {
    ...useNotifications(BulkContentTagDocument, {
      failure: t('api.content_tags.bulk_update_error'),
      success: (data) => {
        const count = data.bulkTag?.taggables.length ?? 0;
        return t('api.content_tags.bulk_update_success_plural', { count });
      },
    }),
    ...options,
  });
};
